module.exports = __webpack_public_path__ + "/img/E-Cap-Labeled-kxyPzK.svg";